import { useEffect, useState } from 'react';
import TimeZoneConverter from '../shared/timezone';
import { TextHighlighter } from '../shared/textBold';
import { useGlobalSearch } from './hooks';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { useSearchParams } from 'react-router-dom';
import { Loader } from 'lucide-react';
import LoaderFull from '../shared/loader-full-screen';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { PAGE_SIZE_OPTIONS } from '../utils';
export const ClientData = ({ data, count, getpageSizeCall,
	setpageSizeCall }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [invData, setInvData] = useState(data);
	const [page, setpage] = useState(1)
	const client_data_hook = useGlobalSearch();
	const [pageSize, setPageSize] = useState(null);
	function  loadClients(pg) { 
		if (searchParams.get('keyword')?.trim() === '' || searchParams.get('keyword') === null) { 
			setInvData([]);
			return;
		}
		
		setInvData([]);
			let bd = {
			keyword: searchParams.get('keyword'),
			client: true,
			client_limit: pageSize,
			client_page: pg,

		  }
		  client_data_hook.mutate(bd)
	}
	useEffect(() => {
	  setInvData(data);
	  setpage(1);
	}, [data])

	useEffect(() => { 
		 loadClients(page)
	}, [page])
	

	useEffect(() => {
	  if (pageSize) { 
		if (page ==1) { 
			loadClients(1)
		}
		else{
			setpage(1)
		}
	  }
	}, [pageSize])
	

	useEffect(() => {
	  if (client_data_hook.isSuccess && client_data_hook.data) {
		setInvData(client_data_hook.data?.client);
	  }
	}, [client_data_hook.isSuccess, client_data_hook.data]);

		useEffect(() => {
		// Define an async function inside useEffect
		const fetchPageSize = async () => {
			try {
				const page_size = await getpageSizeCall();
				console.log(page_size, 'pg in client');
				setPageSize(page_size); // Set the page size state
			} catch (error) {
				console.error('Error fetching page size:', error);
			}
		};

		fetchPageSize(); // Call the async function
	}, []); //

	const handlePageSizeChange = async (event) => {
		const selectedPageSize = event.target.value;
		setPageSize(null);
		let ret = await setpageSizeCall(selectedPageSize);
		try {
			const page_size = await getpageSizeCall();
			console.log(page_size, 'pg in client');
			setPageSize(page_size); // Set the page size state
		} catch (error) {
			console.error('Error fetching page size:', error);
		}
	};	


	return (
		<div className="border pt-5 px-4 pb-0 rounded-lg mt-8 relative">
			<label className="absolute -top-6 left-4 font-black text-primary text-lg px-1 py-2 bg-white">
				Clients
			</label>
			<div className="listDHeight larger overflow-auto">
				{/* Table body head */}
				{invData?.length > 0 && <div className="flex gap-2 mb-2">
						<div className="grow px-5 py-1 text-xs flex items-center justify-between">
							<div className="flex-none w-[140px]">
								<label
									className={`font-black block relative cursor-pointer`}
								>
									Name
								</label>
							</div>
							<div className="flex-none pl-6 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Total Vendor
								</label>
							</div>

							<div className="flex-none pl-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Created Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Updated Date
								</label>
							</div>
						</div>
					</div>}
				{/* Table body Row */}
				{!client_data_hook.isPending && invData?.length ==0 && !['', null].includes(searchParams.get('keyword')) && <div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No data found</p>
					</div>}
				{['', null].includes(searchParams.get('keyword')) && <div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No text searched</p>
					</div>}
				{client_data_hook.isPending ? <LoaderFull /> : invData?.map((obj, index) => {
					return (
						<div className="flex gap-2 mb-2 tblLoop">
						<div className="grow border rounded-md px-5 py-3 text-sm flex items-center justify-between">
							<div className="flex-none w-[140px] relative flex border-r pr-4 items-center">
								<span
									title={obj?.name}
									className="absolute w-full block truncate"
								>
									{obj?.name ? <TextHighlighter text={obj.name} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center border-r pr-4 text-center w-[240px] relative">
								<span
									title={obj?.total_vendors}
									className="absolute w-full block truncate"
								>
									{obj?.total_vendors || <span className="text-gray-500">-</span>}
								</span>
							</div>
							
							<div className="flex-none border-r px-4 text-center w-[240px]">
								<TimeZoneConverter  utcTimestamp={obj?.created_at} />
							</div>
							<div className="flex-none px-4 text-center w-[240px]">
								<TimeZoneConverter  utcTimestamp={obj?.updated_at} />
							</div>
						</div>
					</div>
					);
				})}
			</div>
			<div className="flex justify-center py-2">
				{invData && (
					<>
						<div className="flex items-center justify-between space-x-4">
							{/* Pagination Component */}
							<div className="flex items-center space-x-2">
								{/* <p>Rows per page</p> */}
								{pageSize ? (
									<FormControl
											variant="outlined"
											size="small"
											sx={{
												minWidth: 120,
												'& .MuiOutlinedInput-root': {
												borderRadius: '0.375rem', // rounded-md
												backgroundColor: 'white',
												fontSize: '0.875rem', // text-sm
												},
												'& .MuiOutlinedInput-notchedOutline': {
												borderColor: '#D1D5DB', // border-gray-300
												},
												'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: '#60A5FA', // blue-400 on hover
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: '#3B82F6', // focus:ring-blue-500
												borderWidth: '2px',
												},
											}}
											>
											<InputLabel id="page-size-label">Page Size</InputLabel>
											<Select
												labelId="page-size-label"
												value={pageSize || ''}
												onChange={handlePageSizeChange}
												label="Page Size"
											>
												{PAGE_SIZE_OPTIONS.map((size) => (
												<MenuItem key={size} value={size}>
													{size}
												</MenuItem>
												))}
											</Select>
											</FormControl>
								) : (
									<div className="w-[60px] h-[40px] flex justify-center items-center bg-gray-100 rounded-md text-sm text-center border border-gray-300">
										<span className="material-icons text-sm animate-spin">
											autorenew
										</span>{' '}
										{/* Spinner */}
									</div>
								)}
							</div>
						<Pagination
							page={page}
							onChange={(e, value) => {
								setpage(value);
							}}
							count={Math.ceil(
								count / (pageSize || 20)
							)}
							color="primary"
							variant="outlined"
							shape="rounded"
						/>
					</div>
					</>
				)}
			</div>
		</div>
	);
};
